import { useEPGStore, useTVStore } from '@/shared/store'

import { useEPGCache } from '../cache/hooks/useEPGCache'
import { ExtendedEpgElement } from '@/types/epg/Epg'
import { ChannelType } from '@/shared/types/appTypes'

export const useSetTVAndEpgToStateAndCache = () => {
    const { setEpg } = useEPGStore()
    const { setChannelsData } = useTVStore()
    const { setEpgToCache, setTvToCache } = useEPGCache()

    const setEpgToStoreAndCache = (data: ExtendedEpgElement[]) => {
        if (!data.length) return
        setEpg(data)
        setEpgToCache(data)
    }

    const setTvToStoreAndCache = (data: ChannelType[]) => {
        if (!data.length) return
        setChannelsData(data)
        setTvToCache(data)
    }

    return { setEpgToStoreAndCache, setTvToStoreAndCache }
}
